import { render, staticRenderFns } from "./SignupVendorPromotionForm.vue?vue&type=template&id=2184f784&scoped=true&"
import script from "./SignupVendorPromotionForm.vue?vue&type=script&lang=js&"
export * from "./SignupVendorPromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupVendorPromotionForm.vue?vue&type=style&index=0&id=2184f784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184f784",
  null
  
)

export default component.exports